import { IonIcon } from "@ionic/react";
import {
  helpCircle,
  helpCircleOutline,
  mailOpenOutline,
  mailOutline,
  peopleCircle,
  peopleCircleOutline,
  playCircle,
  playCircleOutline,
  videocamOutline,
} from "ionicons/icons";
import { FaCar } from "react-icons/fa6";
import { GiShoppingCart } from "react-icons/gi";
import { HiMail, HiOutlineMail } from "react-icons/hi";
import {
  HiBookmark,
  HiOutlineBookmark,
  HiOutlineUserCircle,
  HiUserCircle,
} from "react-icons/hi2";
import { IoMdNotifications, IoMdNotificationsOutline } from "react-icons/io";
import { IoSchoolOutline } from "react-icons/io5";
import { MdFlag, MdOutlineFlag } from "react-icons/md";
import { PiFilmSlate, PiFilmSlateFill } from "react-icons/pi";
import { RiHome4Fill, RiHome4Line } from "react-icons/ri";
import { AiIcon } from "../components/form/PostForm";
import { DEFAULT_HOME_PATH } from "./constents";

const VideoIcon = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="28px"
    viewBox="0 -960 960 960"
    width="28px"
    fill="currentColor"
    className="sidebar-left__icon"
  >
    <path d="m380-340 280-180-280-180v360Zm-60 220v-80H160q-33 0-56.5-23.5T80-280v-480q0-33 23.5-56.5T160-840h640q33 0 56.5 23.5T880-760v480q0 33-23.5 56.5T800-200H640v80H320ZM160-280h640v-480H160v480Zm0 0v-480 480Z" />
  </svg>
);
const MailIcon = (props) => <IonIcon icon={mailOutline} {...props} />;
const MailFilledIcon = (props) => <IonIcon icon={mailOpenOutline} {...props} />;
const VideoGeneratorIcon = (props) => (
  <IonIcon icon={videocamOutline} {...props} />
);

const FriendsIcon = (props) => (
  <IonIcon icon={peopleCircleOutline} {...props} />
);
const FriendsFilledIcon = (props) => <IonIcon icon={peopleCircle} {...props} />;
const VideosIcon = (props) => <IonIcon icon={playCircleOutline} {...props} />;
const VideosFilledIcon = (props) => <IonIcon icon={playCircle} {...props} />;
const HelpIcon = (props) => <IonIcon icon={helpCircleOutline} {...props} />;
const HelpFilledIcon = (props) => <IonIcon icon={helpCircle} {...props} />;
const sidebarLinks = [
  {
    text: "Home",
    path: DEFAULT_HOME_PATH,
    icon: RiHome4Line,
    filledIcon: RiHome4Fill,
    class: "home",
  },

  {
    text: "Alerts",
    path: "/alerts",
    icon: IoMdNotificationsOutline,
    filledIcon: IoMdNotifications,
    class: "notification",
  },
  {
    text: "Messages",
    path: "/messages",
    icon: HiOutlineMail,
    filledIcon: HiMail,
    class: "message",
  },
  {
    text: "Bookmarks",
    path: "/bookmarks",
    icon: HiOutlineBookmark,
    filledIcon: HiBookmark,
    class: "bookmark",
  },
  {
    text: "Friends",
    path: "/friends",
    icon: FriendsIcon,
    filledIcon: FriendsFilledIcon,
    class: "friends",
  },
  {
    text: `videos`,
    path: "/videos",
    icon: PiFilmSlate,
    filledIcon: PiFilmSlateFill,
    class: "videos",
  },
  {
    text: "Local Market",
    path: "/market",
    icon: GiShoppingCart,
    class: "market",
  },

  // {
  //   text: "Exams",
  //   path: "/exams",
  //   icon: MdOutlineLibraryBooks,
  //   class: "exams",
  // },
  // {
  //   text: "Students",
  //   path: "/students",
  //   icon: PiStudentFill,
  //   class: "students",
  // },
  {
    text: "LoonLearn",
    path: "/study",
    icon: IoSchoolOutline,
    class: "study",
  },
  {
    text: "ride",
    path: "/ride",
    icon: FaCar,
    class: "travel",
  },
  // {
  //   text: "Email",
  //   path: "/email",
  //   icon: MailIcon,
  //   filledIcon: MailFilledIcon,
  //   class: "email",
  // },
  {
    path: "/loonlock",
    text: "LoonLock",
    icon: () => (
      <span
        style={{ fontSize: "20px", marginRight: "24px" }}
        className="sidebar-left__icon"
      >
        🔐
      </span>
    ),
  },
  // {
  //   text: "LoonAI",
  //   path: "/loon-ai",
  //   icon: AiIcon,
  //   class: "ai",
  // },
  {
    text: "Profile",
    path: "/profile/",
    icon: HiOutlineUserCircle,
    filledIcon: HiUserCircle,
    class: "profile",
  },
  {
    text: "LoonVid",
    path: "/private/llg-7r0xw-b29",
    icon: VideoGeneratorIcon,
    class: "video-generator",
    adminOnly: true,
  },
  {
    text: "Reports",
    path: "/reports",
    icon: MdOutlineFlag,
    filledIcon: MdFlag,
    class: "reports",
    adminOnly: true,
  },

  {
    text: "Flagged Users",
    path: "/flagged-users",
    icon: MdOutlineFlag,
    filledIcon: MdFlag,
    class: "reports",
    adminOnly: true,
  },
  {
    text: "Requests",
    path: "/requests",
    icon: HelpIcon,
    filledIcon: HelpFilledIcon,
    class: "requests",
    adminOnly: true,
  },
  {
    text: "Post",
    path: "/new-post",
    icon: "",
    class: "post",
  },
];

export default sidebarLinks;
